import axios from "axios";
import { toast } from "react-toastify";
import {
  GET_SCREEN_REQUEST,
  GET_SCREEN_SUCCESS,
  GET_SCREEN_FAILURE,
  GET_KYC_PAGE_LIST,
  UPDATE_SCREEN_PAGE,
  UPDATE_DIGILOCKER,
  SET_ADDRESS_FORCEFULLY,
  SET_FORECEFULLY_STATE,
  SET_PD_FORCEFULLY,
  KYC_STATUS_SUCCESS,
  UPDATE_NAVIGATION_KYC_STATUS,
} from "./navigationTypes";
import { getApiHeader, getApiUrl } from "utils";
import { MARFATIA_API_URL, KycPageName } from "utils"; 

export const setForcefullyState = (data) => {
  return {
    type: SET_FORECEFULLY_STATE,
    payload: data,
  };
};

export const setAddressForcefullyRedux = (
  index,
  forcefully = true,
  pageName = "Address"
) => {
  return {
    type: SET_ADDRESS_FORCEFULLY,
    payload: {
      index,
      pageName,
      forcefully,
    },
  };
};
export const setPDForcefullyRedux = (index) => {
  return {
    type: SET_PD_FORCEFULLY,
    payload: index,
  };
};

function checkPanStage(data) {
  let askForPanDetails = false;
  let newarr = [];
  for (let i in data) {
    if (data[i].PAN) {
      if (!data[i].PAN.pan_doc_verified && !data[i].PAN.status) {
        askForPanDetails = true;
      }
    }
  }

  for (let i in data) {
    if (data[i]["Address"]) {
      if (askForPanDetails) {
        data[i]["Address"]["status"] = 0;
        newarr.push(data[i]);
      } else {
        newarr.push(data[i]);
      }
    } else {
      newarr.push(data[i]);
    }
  }
  return {
    data: newarr,
    state: askForPanDetails,
  };
}

export const getStageScreen = (pageName = "default") => {
  const portal_domain = window.sessionStorage.getItem("portal_domain");
  const API_URL = portal_domain
    ? portal_domain.substring(0, portal_domain.length - 1)
    : "";
  const token = window.sessionStorage.getItem("token");
  const headers = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Authorization: `Basic ${token}`,
    },
  };
  return async (dispatch) => {
    dispatch({ type: GET_SCREEN_REQUEST });
    try {
      const resp = await axios.get(
        `${API_URL}/api/method/kyc_customizations.apis.kyc_page.api.get_stage`,
        headers
      );
      if (
        getApiUrl() === MARFATIA_API_URL &&
        resp.data?.data?.kyc_status === "Completed"
      ) {
        return dispatch({
          type: KYC_STATUS_SUCCESS,
          payload: true,
        });
      }
      let panState = false;
      if (resp.data.data) {
        let { data, state } = checkPanStage(resp.data?.data?.kyc_status);
        resp.data.data.kyc_status = data;
        panState = state;
      }
      if (resp.data?.message === "Your KYC has been Completed. Thank You..!") {
        return toast.success(resp.data?.message);
      }
      dispatch({
        type: GET_SCREEN_SUCCESS,
        payload: resp.data?.data,
        panState: panState,
        pageName,
      });
      const dynamicObject = resp.data?.data?.flow?.reduce((acc, key) => {
        acc[key] = KycPageName[key];
        return acc;
      }, {})
      console.log('dynamicObject', dynamicObject) 
      dispatch({
        type: GET_KYC_PAGE_LIST,
        payload: dynamicObject,
      });
      if (pageName == "digilocker") {
        dispatch({
          type: UPDATE_DIGILOCKER,
          payload: true,
        });
      }
    } catch (error) {
      const { response } = error || {};
      toast.dismiss();
      toast.error(response.data?.message);
      dispatch({ type: GET_SCREEN_FAILURE });
      if ([401, 403].includes(response.status)) {
        sessionStorage.removeItem("token");
        sessionStorage.clear();
        localStorage.clear();
      }
    }
  };
};

export const updateScreenPage = () => {
  return async (dispatch) => {
    dispatch({
      type: UPDATE_SCREEN_PAGE,
    });
  };
};

export const updateNavigationKycStatus = (data) => {
  return {
    type: UPDATE_NAVIGATION_KYC_STATUS,
    payload: data,
  };
};
export const createKycForExistingUser = (payload) => {
  return async (dispatch) => {
    try {
      await axios.post(
        `${getApiUrl()}/api/method/kyc_customizations.apis.newkyc_sameuser.newkycforsameuser.create_kyc_existing_user`,
        payload,
        getApiHeader()
      );
      dispatch({
        type: KYC_STATUS_SUCCESS,
        payload: false,
      });
      window.location.reload();
    } catch (err) {
      const { data } = err.response || {};
      toast.error(data.message?.message || "Internal server error!");
    }
  };
};

export const resetIsKycStatusCompleted = () => {
  return async (dispatch) => {
    dispatch({
      type: KYC_STATUS_SUCCESS,
      payload: false,
    });
    toast.success("Your KYC has been Completed. Thank You..!");
    sessionStorage.removeItem("token");
  };
};
